export default "__VITE_PUBLIC_ASSET__b6a43b4c__"